<h2 mat-dialog-title>Enter name of new set</h2>
<mat-dialog-content>
  <mat-form-field appearance="fill" class="full-width">
    <mat-label>Set Name</mat-label>
    <input #setName matInput placeholder="Set Name">
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <!-- The mat-dialog-close directive optionally accepts a value as a result for the dialog. -->
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-raised-button color="accent" [mat-dialog-close]="setName.value" cdkFocusInitial>Submit</button>
</mat-dialog-actions>